import clsx from 'clsx';
import { FC } from 'react';
import { DateField as DateFieldType, IDateComponent } from '../../../types';
import Field from '../field';

const DateComponent: FC<IDateComponent> = props => {
  const { selected, onChange, disabled = false, fullwidth = false, controlProps = {} } = props;

  const fullwidthClass = fullwidth ? 'is-fullwidth' : '';

  return (
    <div className={clsx('control', fullwidthClass)} {...controlProps}>
      <input
        type="date"
        value={selected ? selected.toISOString().split('T')[0] : ''}
        onChange={e => onChange(e.target.value ? new Date(e.target.value) : null)}
        className={clsx('input', fullwidthClass)}
        disabled={disabled}
      />
    </div>
  );
};

const DateField: FC<DateFieldType> = props => {
  const {
    label,
    labelProps,
    fullwidth = false,
    required = false,
    errorMessage,
    ...componentProps
  } = props;

  return (
    <Field
      label={label}
      labelProps={labelProps}
      fullwidth={fullwidth}
      required={required}
      errorMessage={errorMessage}>
      <DateComponent {...componentProps} fullwidth={fullwidth} />
    </Field>
  );
};

export default {
  Component: DateComponent,
  Field: DateField,
};
